import { applyMiddleware, createStore } from 'redux';
import { createLogger }                 from 'redux-logger'
import { composeWithDevTools }          from 'redux-devtools-extension';
import thunk                            from 'redux-thunk';
import { routerMiddleware }             from 'react-router-redux'
import createHistory                    from 'history/createBrowserHistory';

import reducers           from './reducers';
import { createMiddleware } from './middleware';

export const history = createHistory();

// Build the middleware for intercepting and dispatching navigation actions
const myRouterMiddleware = routerMiddleware(history);

const getMiddleware = async () => {
	if (process.env.NODE_ENV === 'production') {
		return applyMiddleware(myRouterMiddleware, await createMiddleware(), thunk);
	} else {
		// Enable additional logging in non-production environments.
		return applyMiddleware(myRouterMiddleware, await createMiddleware(), thunk, createLogger())
	}
};

export const createTheStore = async () => {
	const middleware = await getMiddleware();

	return createStore(reducers, composeWithDevTools(middleware));
}



// WEBPACK FOOTER //
// /src/store/store.js